import { render, staticRenderFns } from "./Dashboard_Main.vue?vue&type=template&id=73ae53ac&align=center&"
import script from "./Dashboard_Main.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports